import Contract from "slotworks/utils/contract";
import gameState from "slotworks/model/game-state";
import ScatterResult from "slotworks/model/gameplay/records/results/scatter-result";
import Components from "slotworks/components/components";
import { parallel, sequence } from "slotworks/utils/race-utils";
import Layers from "slotworks/graphics/layers/layers";
import * as TweenJS from "slotworks/utils/tween";
import { DimSymbolsCommand } from "slotworks/commands/symbols/dim-symbols-command";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import soundManager from "slotworks/sound/sound-manager";

export default function CelebrateScatterCommand(): Contract<void> {
    if(gameState.getCurrentGame().isBuyout) {
        return Contract.empty();
    }
    return new Contract(resolve => {
        const record = gameState.getCurrentGame().getCurrentRecord();

        if(!record) {
            resolve(null);
            return;
        }
        
        const results = record.getResultsOfType(ScatterResult);
        if(results && results.length > 0) {
            
            const result = results[0] as ScatterResult;
            const tweenFunctions = [];
            const winningSymbols: SymbolComponent[] = [];
            for(let position of result.positions) {
                const symbol = Components.matrix.getSymbol(position.x, position.y);
                winningSymbols.push(symbol);
                tweenFunctions.push(() => symbol.win());
            }
            DimSymbolsCommand(Components.matrix.getAllSymbols()).execute();
            soundManager.customEvent("scatter_win");
            parallel(tweenFunctions).then(() => {
                for(let symbol of winningSymbols) symbol.static();
                setTimeout(resolve, 500);
            });
        } else 
            resolve(null);
    });
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/commands/celebrate-scatter-command.ts